import { urls } from "../urls";
import { useCallback, useEffect, useRef, useState } from "react";
import {
    generateRBScubscriptionQueryParams, getCurrentEnv,
    LogConfig,
    logger
} from "../utils";
import { QueryRequestBody } from "interfaces/common";
import { PageNames } from "interfaces/config";
import { useLoginStore, useNavStore, useTableStore } from "../state";
import { AlertColor } from "customEnums/AlertColor";
import { useRapbackMaintenanceStore } from '../pages/RapbackSubscriptions/RapbackMaintenance/state'
import { TableNames } from "customEnums/TableNames";
import { Auth } from "aws-amplify";
import { useAuth } from "./useAuth";
import { handleUnauthorized } from "utils/handleUnauthorized";

export const getCount = (obj: object) => {
    return Object.values(obj).filter(value => value === true).length
}

interface RunQueryConfig {
    refs: {
        runCount: number,
        orderByRef: string,
        orderRef: string,
        pageSizeRef: number,
        pageRef: number
    },
    dependencies: any,
    runCountOverTwo: boolean,
    initialInvocation: boolean,
    caughtOldSearch: boolean,
    pageChanged: boolean,
    pageSize: number,
    currentPage: number,
    order: string,
    orderBy: string,
    tableName: string,
    userRole: string,
    filterLabels: any[],
    searchParams: any[],
    pageName: string,
    searchingNonRbPage: boolean
}

export enum RbSubAction {
    CONFRIM_PRENOTIFICATION = "CONFIRM_PRENOTIFICATION",
    DENY_PRENOTIFICATION = "DENY_PRENOTIFICATION",
    UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION",
    UNSUBSCRIBE = "UNSUBSCRIBE",
    RENEW = "RENEW"
}

export const useRapbackSubscription = (
    pageName: string,
    pageSize: number,
    currentPage: number,
    userRole: any,
    searchParams: any,
    auditSearch: boolean,
    tableName: string = "",
    calledFromAuthHook: boolean = false
) => {

    const STATE = getCurrentEnv
    const queryUrl = urls.QUERY
    const rapbackUrl = urls.RAPBACK

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState()
    const [mappedData, setMappedData] = useState<any>()
    const [totalRecords, setTotalRecords] = useState(0);
    const setAlertTitle = useTableStore(state => state.setAlertTitle);
    const setAlertMessage = useTableStore(state => state.setAlertMessage);
    const setSeverity = useTableStore((state) => state.setSeverity)
    const setOpenNotification = useTableStore((state) => state.setOpenNotification)
    const setNeedsAttention = useNavStore(state => state.setNeedsAttention);
    const fullName = useRapbackMaintenanceStore(state => state.fullName)
    const setReceivedResponse = useTableStore((state) => state.setReceivedResponse)
    const columnState = useTableStore(state => state.columnState)
    const tableConfig = useTableStore(state => state.tableConfig)
    const runFilters = useTableStore(state => state.runFilters)
    const setRunFilters = useTableStore(state => state.setRunFilters)
    const runCount = useRef(0);
    const pageRef = useRef(currentPage)
    const pageSizeRef = useRef(pageSize)

    const [refetchParams, setRefetchParams] = useState<any>({})
    const { logout } = useAuth();

    const pagination = useTableStore(state => state.pagination)

    const { order, orderBy } = pagination[tableName]
    const orderByRef = useRef(orderBy)
    const orderRef = useRef(order)

    const initialInvocation = useNavStore(state => state.initialInvocation)
    const updatePrenotifications = useNavStore(state => state.updatePrenotifications)
    const updateValidations = useNavStore(state => state.updateValidations)
    const setInitialInvocationFalse = useNavStore(state => state.setInitialInvocationFalse)
    const userAcceptingTerms = useLoginStore(state => state.userAcceptingTerms)

    console.log('run useRBSub orderBy in query ', { orderBy, pageName })

    const statusFilters = columnState.page["rapback-maintenance"]!.filters?.find(filter => filter.filterLabel === "Filter Status")
    const timeFilters = columnState.page["rapback-validations"]!.filters?.find(filter => filter.filterLabel === "Time Remaining")

    const getActiveValidations = (results) => {
        let activeValidations: any[] = []
        results.forEach((result: any) => {

            if (result.daysToExpire <= 60 && Math.sign(result.daysToExpire) === 1 && result.daysToExpire !== null && result.isActive === "true") {
                console.log('set needs attention true')
                activeValidations.push(result)
                setNeedsAttention(true)
            }

        });
        if (activeValidations.length) {
            setNeedsAttention(true)
        }
        return activeValidations.length
    }

    const fetchMaintenance = useCallback(async (queryDataRequest: any, action?: RbSubAction | undefined) => {
        console.log('debug rb sub useEffect dependencies: useRapbacksubscription fetchMaintenance: ', initialInvocation)
        const url: string = `${process.env.NODE_ENV === "production" ? queryUrl : ""}/query`;
        try {
            setLoading(true)
            let outstandingPrenotificationsNum;
            let outstandingValidationsNum;

            const data = await (await fetch(url, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(queryDataRequest)
            })).json();

            console.log('useRapbacksubscription data: ', { rqueriesReultsLength: data['queriesResults'].length > 1, initialInvocation, data })

            handleUnauthorized(data.message, logout);
            setTotalRecords(data['queriesResults'][0].fullCount)

            //let updatedOutstandingRapback = { ...outstandingRapback }
            if (initialInvocation) {
                outstandingPrenotificationsNum = data['queriesResults'][0].fullCount //prenotification is prefiltered and can use fullCount
                updatePrenotifications(outstandingPrenotificationsNum)
                outstandingValidationsNum = data['queriesResults'][1].fullCount
                updateValidations(outstandingValidationsNum) //confirm expired results are sorted to the bottom - sort desc not working in staging
                setInitialInvocationFalse()
            } else {
                const { results } = data['queriesResults'][0];

                console.log('useRapbacksubscription NOT initial request: ', { results, action, pageName })

                if (pageName === PageNames.RAPBACK_PRENOTIFICATIONS || action === RbSubAction.CONFRIM_PRENOTIFICATION || action === RbSubAction.DENY_PRENOTIFICATION) {
                    updatePrenotifications(data['queriesResults'][0].fullCount)
                } else if (pageName === PageNames.RAPBACK_VALIDATIONS || action === RbSubAction.RENEW || action === RbSubAction.UNSUBSCRIBE) {
                    updateValidations(data['queriesResults'][0].fullCount)
                }

                setMappedData(results);
                setLoading(false);
            }

        } catch (err: any) {
            console.error('error querying rapback subs: ', err)
            setError(err);
            setLoading(false);
        }
    }, [initialInvocation])

    const handleConfirmPrenotification = async (subscriptionId: string) => {
        console.log(`handleConfirmPrenotification ran`)
        const { username } = await Auth.currentAuthenticatedUser();
        const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/confirm/${subscriptionId}?username=${username}`;

        try {
            const resp = await fetch(url, {
                method: "POST",
                credentials: "include"
            })

            if (resp.ok) {
                fetchMaintenance(refetchParams.queryDataRequest, RbSubAction.CONFRIM_PRENOTIFICATION)

                setAlertTitle("Request Submitted");
                setAlertMessage(`A pre-notification acceptance request has been submitted for ${fullName}. View pending details on the Rapback Maintenance screen.`)
                setSeverity(AlertColor.SUCCESS)
                setOpenNotification(true)
                setReceivedResponse(true)
            } else {
                setOpenNotification(true);
                setSeverity(AlertColor.ERROR)
                setAlertTitle(`Request Failed`)
                setAlertMessage(`Please try again to accept ${fullName}'s subscription`)
                setReceivedResponse(true)
            }
        } catch (err: any) {
            setError(err)
        }
    }

    const handleDenyPrenotification = async (subscriptionId: string) => {
        const { username } = await Auth.currentAuthenticatedUser();
        const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/deny/${subscriptionId}?deletion_source=prenotify&username=${username}`;

        try {
            const resp = await fetch(url, {
                method: "POST",
                credentials: "include"
            })

            if (resp.ok) {
                fetchMaintenance(refetchParams.queryDataRequest)
                setAlertTitle("Request Submitted");
                setAlertMessage(`A pre-notification rejection request has been submitted for ${fullName}. View pending detials on the Rapback Maintenance Screen.`)
                setSeverity(AlertColor.SUCCESS)
                setOpenNotification(true)
                setReceivedResponse(true)
                fetchMaintenance(refetchParams.queryDataRequest)

            } else {
                setOpenNotification(true);
                setSeverity(AlertColor.ERROR)
                setAlertTitle(`Request Failed`)
                setAlertMessage(`Please try again to decline ${fullName}'s subscription`)
                setReceivedResponse(true)
            }
        } catch (err: any) {
            setError(err)
        }
    }

    const handleUpdateSubscription = async (subscriptionId: string, expirationDate?: string, dob?: string) => {
        const { username } = await Auth.currentAuthenticatedUser();
        const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/update/${subscriptionId}?username=${username}`;

        //Old format for name reference
        // const body = {
        //     expiration_date: expirationDate,
        //     dob,
        //     rapback_id: subscriptionId
        // }

        const body = { rapback_id: subscriptionId }

        if (expirationDate) body['expiration_date'] = expirationDate
        if (dob) body['dob'] = dob

        console.log('handleUpdateSub body: ', body)
        try {
            const resp = await fetch(url, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(body)
            })
            if (resp.ok) {
                fetchMaintenance(refetchParams.queryDataRequest)

                setAlertTitle("Request Successfully Submitted");
                setAlertMessage(`Edit Requests will be reviewed`)
                setSeverity(AlertColor.SUCCESS)
                setOpenNotification(true)
                setReceivedResponse(true)
                fetchMaintenance(refetchParams.queryDataRequest)

            } else {
                setOpenNotification(true);
                setSeverity(AlertColor.ERROR)
                setAlertTitle(`Request Error`)
                setAlertMessage(`Your attempt to edit has failed, please try again or contact support`)
                setReceivedResponse(true)
            }
        } catch (err: any) {
            setError(err)
        }
    }

    const handleUnsubscribe = async (subscriptionId: string) => {
        const { username } = await Auth.currentAuthenticatedUser();
        const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/unsubscribe/${subscriptionId}?deletion_source=${pageName === "rapback-maintenance" ? "maintenance" : "validation"}&username=${username}`;

        try {
            const resp = await fetch(url, {
                method: "POST",
                credentials: "include"
            })

            console.log('unsubscribe response: ', resp)
            if (resp.ok) {
                if (pageName === "rapback-maintenance") {
                    fetchMaintenance(refetchParams.queryDataRequest)
                    setOpenNotification(true);
                    setAlertTitle("Request Successfully Submitted");
                    setAlertMessage(`Unsubscribe request will be reviewed. If approved, ${fullName} will be unsubscribed from receiving Rapbacks.`)
                    setSeverity(AlertColor.SUCCESS)
                    setReceivedResponse(true)
                }
                if (pageName === "rapback-validations") {
                    setAlertTitle("Request Submitted");
                    setAlertMessage(`A rapback subscription cancellation request has been submitted for ${fullName}. View pending detials on the Rapback Maintenance Screen.`)
                    setSeverity(AlertColor.SUCCESS)
                    setOpenNotification(true)
                    setReceivedResponse(true)

                }
                console.log('debug refetch unsubscribe: ', refetchParams)
                fetchMaintenance(refetchParams.queryDataRequest)
                return resp.ok
            } else {
                if (pageName === "rapback-maintenance") {
                    setOpenNotification(true);
                    setSeverity(AlertColor.ERROR)
                    setAlertTitle(`Request Error`)
                    setAlertMessage(`Your attempt to unsubscribe ${fullName} has failed, please try again or contact support.`)
                    setReceivedResponse(true)
                }
                if (pageName === "rapback-validations") {
                    setOpenNotification(true);
                    setSeverity(AlertColor.ERROR)
                    setAlertTitle(`Request Failed`)
                    setAlertMessage(`Please try again to cancel ${fullName}'s subscription`)
                    setReceivedResponse(true)
                }
                return false
            }
        } catch (err: any) {
            setError(err)
        }
    }

    const handleRenew = async (subscriptionId: string) => {
        console.log(`Validations handleRenew hook subscriptionId: ${subscriptionId}`)
        const { username } = await Auth.currentAuthenticatedUser();

        const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/renew/${subscriptionId}?username=${username}`;

        console.log(`Validations handleRenew hook url: ${url}`)

        try {
            console.log(`Validations handleRenew hook fetching....`)

            const resp = await fetch(url, {
                method: "POST",
                credentials: "include"
            })

            if (resp.ok) {
                fetchMaintenance(refetchParams.queryDataRequest, RbSubAction.RENEW)
                setAlertTitle("Request Submitted");
                setAlertMessage(`A rapback subscription renewal request has been submitted for ${fullName}. View pending details on the Rapback Maintenance screen.`)
                setSeverity(AlertColor.SUCCESS)
                setOpenNotification(true)
                setReceivedResponse(true)
            } else {
                setOpenNotification(true);
                setSeverity(AlertColor.ERROR)
                setAlertTitle(`Request Failed`)
                setAlertMessage(`Please try again to renew ${fullName}'s subscription`)
            }
            return resp.ok
        } catch (err: any) {
            setError(err)
        }
    }

    const getRunQuery = (runQueryConfig: RunQueryConfig) => {
        const { dependencies, pageChanged, filterLabels } = runQueryConfig
        const { initialInvocation, tableName, tableConfig, calledFromAuthHook } = dependencies

        let awaitingExpectedFilters = tableConfig[tableName]?.filter && filterLabels.length < 1

        if (Object.keys(tableConfig).length || initialInvocation) {
            console.log('1010101 debug rb sub useEffect dependencies should only log if tableConfig or initialInvocation are present')
            if ((awaitingExpectedFilters === undefined || awaitingExpectedFilters === true) && !initialInvocation) {
                console.log('debug rb sub condition false')
                return false
            } else if (/* initialInvocation || */ pageChanged) {
                return true

            } else if (calledFromAuthHook && !initialInvocation) {
                return false
            }
        } else {
            return false
        }
    }

    useEffect(() => {
        console.log('1010101 debug rb sub useEffect dependencies: ', {
            STATE,
            userRole,
            pageSize,
            currentPage,
            order,
            orderBy,
            searchParams,
            runFilters,
            columnState: columnState.page[pageName][tableName]?.filters?.length,
            statusFilters,
            timeFilters,
            tableName,
            initialInvocation,
            pageName,
            calledFromAuthHook,
            tableConfig: tableConfig[tableName],
            runCountCurrent: runCount.current,
            pageChanged: (pageRef.current !== currentPage || (pageRef.current === 1 && currentPage === 1) || pageSizeRef.current !== pageSize) || (orderByRef.current !== orderBy || orderRef.current !== order)


            //filtersLength: columnState.page[pageName][tableName]!.filters?.length,
        })
        runCount.current = runCount.current + 1;
        const controller = new AbortController();
        //update column names for dates
        const dateIndexs = [
            "expirationDate",
            "lowerDate",
            "upperDate",
            "dob",
            "subscriptionDate",
            "deletionDate",
            "receivedDate"
        ]
        const param = searchParams.find((param) => dateIndexs.includes(param.column))

        let filters = columnState.page[pageName][tableName]?.filters
        const filterLabels: any[] = []
        let filterNumbers: any[] = []
        if (filters) {
            filters.forEach(filter => {
                let filterValueKeys = Object.keys(filter.filterValues);
                filterValueKeys.forEach(key => {
                    const { boolNumber, selected, label } = filter.filterValues[key];
                    if (pageName === "rapback-validations") {
                        filterNumbers.push(boolNumber);
                    }
                    if (selected) {
                        if (pageName === "rapback-maintenance") {
                            filterLabels.push(label);
                        } else if (pageName === "rapback-validations") {
                            filterLabels.push(boolNumber);
                        }
                    }
                });
            });
        }

        const runQueryConfig: any = {
            refComps: {
                runCount: runCount.current,
                pageRef: pageRef.current,
                currentPage,
                pageSizeRef: pageSizeRef.current,
                pageSize,
                orderByRef: orderByRef.current,
                orderBy,
                orderRef: orderRef.current,
                order
            },
            dependencies: {
                STATE,
                initialInvocation,
                pageSize,
                currentPage,
                order,
                orderBy,
                tableName,
                userRole,
                tableConfig,
                columnStateLength: columnState.page[pageName][tableName]?.filters?.length,
                runFilters,
                searchParams,
                calledFromAuthHook
            },
            caughtOldSearch: searchParams?.length > 0 && runCount.current <= 2,
            pageChanged: (pageRef.current !== currentPage || (pageRef.current === 1 && currentPage === 1) || pageSizeRef.current !== pageSize) || (orderByRef.current !== orderBy || orderRef.current !== order),
            runCountOverTwo: runCount.current > 2 && runFilters,
            searchingNonRbPage: searchParams?.length > 0 && pageName !== PageNames.RAPBACK_MAINTENANCE && pageName !== PageNames.RAPBACK_VALIDATIONS && pageName !== PageNames.RAPBACK_PRENOTIFICATIONS,
            filterLabels,
            pageName,
        }

        //console.log('debug rb sub useEffect dependencies', {...runQueryConfig});

        let runQuery = getRunQuery(runQueryConfig)

        console.log('1010101 debug rb sub useEffect dependencies debug rb sub ', { runQuery })

        if (runQuery) {

            let queryDataRequest: QueryRequestBody = {
                "queries": initialInvocation ? [
                    {
                        "queryParams": [...generateRBScubscriptionQueryParams('rapback-prenotifications', searchParams, filterLabels, filterNumbers, 'subscriptionDate', order, param)],
                        "limit": pageSize,
                        "offset": (currentPage - 1) * pageSize,
                        "queryName": "queryRapbackSubscriptionTable",
                        "transformData": true

                    },
                    {
                        "queryParams": [...generateRBScubscriptionQueryParams('rapback-validations', searchParams, filterLabels, filterNumbers, 'daysToExpire', 'desc', param)],
                        "limit": pageSize,
                        "offset": (currentPage - 1) * pageSize,
                        "queryName": "queryRapbackSubscriptionTable",
                        "transformData": true
                    },
                ] : [
                    {
                        "queryParams": [...generateRBScubscriptionQueryParams(pageName, searchParams, filterLabels, filterNumbers, orderBy, order, param)],
                        "limit": pageSize,
                        "offset": (currentPage - 1) * pageSize,
                        "queryName": "queryRapbackSubscriptionTable",
                        "transformData": true
                    }
                ]
            };

            const debugGetRunQuery: LogConfig = {
                identifier: "debug rb sub",
                pageName,
                thingToDebug: "runQuery",
                paramsToLog: {
                    conditionA: tableConfig[tableName]?.filter && filterLabels.length < 1,
                    conditionB: initialInvocation && !runQueryConfig.searchingNonRbPage,
                    conditionC: runQueryConfig.searchingNonRbPage,
                    conditionD: runQueryConfig.caughtOldSearch,
                    conditionE: runQueryConfig.pageChanged,
                    conditionF: !initialInvocation,
                    isPrenotification: pageName === PageNames.RAPBACK_PRENOTIFICATIONS,
                    runPrenotificationQuery: userRole.length > 1,
                    runMaintenanceValidationsQuery: userRole && filterLabels.length > 0,
                    runQuery,
                    initialInvocation,
                    tableConfig
                }
            }
            // console.log utility 
            logger(debugGetRunQuery)



            if (STATE === "ga") {
                console.log('debug rb maintenance calling fetching maintence data ', STATE === 'ga')
                setRefetchParams({ queryDataRequest })
                if (!initialInvocation && !calledFromAuthHook) {
                    console.log('debug rb sub useEffect dependencies before fetchMaintenance call: ', { initialInvocation, calledFromAuthHook, runFetchMaintenance: !initialInvocation && !calledFromAuthHook })

                    fetchMaintenance(queryDataRequest)
                }
            }

        }
        setRunFilters(false)
        console.log('debug searchParams: ', searchParams)
    }, [STATE,
        userRole,
        pageSize,
        currentPage,
        order,
        orderBy,
        searchParams,
        searchParams?.length,
        runFilters,
        columnState.page[pageName][tableName]?.filters?.length,
        tableName,
        initialInvocation,
        initialInvocation ? tableConfig["transaction-sumarry"] : tableConfig[tableName],
        calledFromAuthHook
    ]

    )

    return { data: mappedData, runCount: runCount.current, error, loading, totalRecords, fetchMaintenance, refetchParams, handleConfirmPrenotification, handleDenyPrenotification, handleUpdateSubscription, handleUnsubscribe, handleRenew };
}


